import { render, staticRenderFns } from "./sidebar-field-grid.vue?vue&type=template&id=2d0f7680&scoped=true"
import script from "./sidebar-field-grid.vue?vue&type=script&lang=js"
export * from "./sidebar-field-grid.vue?vue&type=script&lang=js"
import style0 from "./sidebar-field-grid.vue?vue&type=style&index=0&id=2d0f7680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f7680",
  null
  
)

export default component.exports